import { Component } from '@angular/core';


@Component({
    selector: 'notifications-dropdown-footer',
    template: `
        <div class="pr-1 mt-1">
            <ng-content></ng-content>
        </div>
    `,
})
export class NotificationsDropdownFooterComponent {}
